import React, { useRef, useEffect } from 'react';

const TrustBox = props => {
  const { id, templateId } = props;
  const ref = useRef(null);
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div className="trustbox">
      <div
        ref={ref}
        className="trustpilot-widget"
        data-businessunit-id="58106ed30000ff00059692f3"
        data-font-family="Roboto"
        data-locale="en-GB"
        data-sku={id}
        data-no-reviews="hide"
        data-style-height="24px"
        data-template-id={templateId}
        data-text-color="#191919"
        data-theme="light"
      />
    </div>
  );
};
export default TrustBox;
